import * as React from 'react';
import Keywords from './Keywords';
import { DefaultButton } from '../ActionButton/ActionButton';

interface IOrganizationProps {
  orgData: any;
}

const Organization: React.FC<IOrganizationProps> = ({ orgData }) => {
  const location = React.useMemo(() => {
    const { street, city, country, postCode } = orgData.location;
    return `${street}, ${city}, ${country}, ${postCode}`;
  }, [orgData.location]);

  const gotToWebsite = React.useCallback(() => {
    let url = orgData?.organizationUrl;
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }
    window.open(url);
  }, [orgData.organizationUrl]);
  return (
    <div className="organization-data org-container">
      <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{orgData?.name}</div>
      <div>{orgData?.description || ''}</div>
      <Keywords keywords={orgData?.keywords} />
      <div className="col">
        <div className="organization-data">
          <span style={{ color: 'red', fontWeight: 'bold' }}>Location</span>
          <span>{location}</span>
        </div>
        <div className="organization-data">
          <span style={{ color: 'red', fontWeight: 'bold' }}>Type</span>
          <span>{orgData?.type}</span>
        </div>
        <div className="organization-data">
          <span style={{ color: 'red', fontWeight: 'bold' }}>Vat Number</span>
          <span>{orgData?.vatNumber}</span>
        </div>
        <div className="organization-data">
          <span style={{ color: 'red', fontWeight: 'bold' }}>Pic Id</span>
          <span>{orgData?.picId}</span>
        </div>
      </div>
      {orgData?.organizationUrl && (
        <div>
          <DefaultButton handleClick={() => gotToWebsite()} text="Website" />
        </div>
      )}
    </div>
  );
};

export const OrganizationData = React.memo(Organization);
